var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-box"},[_c('v-row',[_c('div',{staticClass:"col-md-12 home-tabs-body pa-5"},[_c('Breadcrumbs',{attrs:{"title":'Calendar'}}),_c('Calendar')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }